import { useContext } from "react";
import { LocalStoreContext } from "../store/LocalStore";
import { RefContext } from "../store/RefContext";
import { config as legendConfig } from "../filterlist/config";

export const Legend = () => {    
  const refs = useContext(RefContext);
  const itemStyle = {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    fontSize: legendConfig.fontSize,
  };
  const boxStyle = {
    width: 10,
    height: 10,
    marginLeft: 10,
    marginRight: 10,
  };

  const [lstore] = useContext(LocalStoreContext);
  const { filter } = lstore;

  return filter.Ticker && filter.Ticker.length > 0 ? (
    <div>
      {filter.Ticker.sort().map((item, i) => {
        return (
          <div key={i} style={itemStyle}>
            <div style={{...boxStyle,backgroundColor:refs.tickerPalette.current[item]}}></div>
            <div>{item}</div>
          </div>
        );
      })}
    </div>
  ) : null;
};
